import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class AppPropertiesConfigService {

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;

  addAppPropertiesConfig(body:any){
    return this.http.post(this.base_URL+'appPropertiesConfig',body)
  }

  getAllAppPropertiesConfig(){
    return this.http.get(this.base_URL+'appPropertiesConfig/all/'+sessionStorage.getItem('cid'))
  }

  getAppPropertiesConfigById(id:any){
    return this.http.get(this.base_URL+'appPropertiesConfig/'+id+'/'+sessionStorage.getItem('cid'))
  }

  deleteAppPropertiesConfig(id:any){
    return this.http.delete(this.base_URL+'appPropertiesConfig/hardDelete/'+id)
  }

  updateAppPropertiesConfig(body:any){
    return this.http.put(this.base_URL+'appPropertiesConfig/update',body)
  }

  getAppPropertiesConfigByWildSearch(wildSearch:any){
    return this.http.get(this.base_URL+'appPropertiesConfig/wildSearch/'+wildSearch+"/"+sessionStorage.getItem('cid'))
  }
}
